var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 36,
    height: 24,
    rx: 4,
    transform: "translate(48 401)",
    fill: "#ededed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mx-flag",
    transform: "translate(-48 -401)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mexico-flag",
    transform: "translate(48 401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M2.7,88.273A2.72,2.72,0,0,0,0,91.016v18.513a2.72,2.72,0,0,0,2.7,2.743H12v-24Z",
    transform: "translate(0 -88.273)",
    fill: "#0b6946"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 12,
    height: 24,
    transform: "translate(12 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M350.637,88.273h-9.3v24h9.3a2.72,2.72,0,0,0,2.7-2.743V91.016A2.72,2.72,0,0,0,350.637,88.273Z",
    transform: "translate(-317.333 -88.273)",
    fill: "#d00a1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M257.07,263.893l-1.07.545v.545h.535Z",
    transform: "translate(-238 -251.328)",
    fill: "#ffd250"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(15.056 12.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M252.461,276.947a.27.27,0,0,1-.268-.272v-1.089a.268.268,0,1,1,.535,0v1.089A.27.27,0,0,1,252.461,276.947Z",
    transform: "translate(-249.517 -274.224)",
    fill: "#00c3a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M217.075,261.724a4.156,4.156,0,0,1-2.858-1.162.276.276,0,0,1-.014-.385.265.265,0,0,1,.378-.014,3.568,3.568,0,0,0,4.988,0,.265.265,0,0,1,.378.014.276.276,0,0,1-.014.385A4.157,4.157,0,0,1,217.075,261.724Z",
    transform: "translate(-214.131 -260.09)",
    fill: "#00c3a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M230.586,284.6a3.421,3.421,0,0,1-1.922-.59l.3-.454a2.942,2.942,0,0,0,3.251,0l.3.454A3.42,3.42,0,0,1,230.586,284.6Z",
    transform: "translate(-212.586 -269.589)",
    fill: "#00aadc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M240.831,246.764l-.591.931-.1.306,1.539-.363Z",
    transform: "translate(-223.255 -235.425)",
    fill: "#732d37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M209.143,214.019c-.707,0-1.557-.606-1.782-1.956l.528-.091c.187,1.123.866,1.5,1.273,1.5.125,0,.255-.047.266-.137.012-.107.015-.133-.265-.229a.964.964,0,0,1-.446-.253c-.49-.569.173-1.171.492-1.46.056-.051.079-.094.073-.111a.285.285,0,0,0-.241-.117.655.655,0,0,1-.673-.51.732.732,0,0,1,.349-.816l.246.484a.191.191,0,0,0-.075.2c.007.028.023.094.153.094a.8.8,0,0,1,.741.468.63.63,0,0,1-.217.711c-.352.319-.562.56-.445.7a.748.748,0,0,0,.214.1c.241.083.689.237.625.808a.742.742,0,0,1-.783.619Z",
    transform: "translate(-192.781 -201.143)",
    fill: "#aad264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M256.535,204.392a1.2,1.2,0,0,0-.535-1.634s3.747-.545,3.212,4.357h0a4.2,4.2,0,0,1-1.059-1.225l-1.617-.953v-.545Z",
    transform: "translate(-238 -194.551)",
    fill: "#874150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M256,241.055l2.676,1.634-1.071.545L256,241.6Z",
    transform: "translate(-238 -230.124)",
    fill: "#732d37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M240.775,211.151h0a.54.54,0,0,1,.535.545h0a1.081,1.081,0,0,0-.2,1.232l.121.246a1.067,1.067,0,0,0,.2.277l1.485,1.512v-.753a6.128,6.128,0,0,0-.627-2.7h0a1.6,1.6,0,0,0-1.436-.9h-.078v.545Z",
    transform: "translate(-223.845 -201.854)",
    fill: "#783c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M233.7,210.6l-.535.545v.545s.637-.328.851-.433a.2.2,0,0,0,.037-.329C233.983,210.866,233.7,210.6,233.7,210.6Z",
    transform: "translate(-216.768 -201.852)",
    fill: "#ffd250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M195.842,253.3a4.6,4.6,0,0,1-4.55-4.63h.535a4.015,4.015,0,1,0,8.029,0h.535A4.6,4.6,0,0,1,195.842,253.3Z",
    transform: "translate(-177.842 -237.193)",
    fill: "#aad264"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(13.651 12.722)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    transform: "translate(0.803 1.305)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    transform: "translate(2.107 2.292)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    transform: "translate(8.009)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    transform: "translate(7.206 1.305)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.363,
    cy: 0.37,
    rx: 0.363,
    ry: 0.37,
    transform: "translate(5.901 2.292)",
    fill: "#ffe15a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M245.651,287.82h-.535a.54.54,0,0,1-.535-.545h0a.54.54,0,0,1,.535-.545h.535a.54.54,0,0,1,.535.545h0A.54.54,0,0,1,245.651,287.82Z",
    transform: "translate(-227.383 -272.532)",
    fill: "#ffb478"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M258.152,205.89a1.987,1.987,0,0,0,1.059,1.225h0c.535-4.9-3.212-4.357-3.212-4.357C258.676,202.758,258.152,205.89,258.152,205.89Z",
    transform: "translate(-238 -194.551)",
    fill: "#9b4b5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.21675a09232823277a7fd0b2d0cd20aa.svg";
export { ForwardRef as ReactComponent };